import request from './request'

// 项目新增
export function projectNew (data) {
  return request.post('en/project/add', data, 'json')
}
// 项目列表
export function projectList (data) {
  return request.get('en/project/list', data, 'json')
}
// 项目删除
export function projectDelete (data) {
  return request.post('en/project/delete', data)
}
// 项目详情
export function projectInfo (data) {
  return request.get('en/project/getInfo', data)
}
// 项目更新
export function projectUpdate (data) {
  return request.post('en/project/update', data, 'json')
}
// 项目拷贝
export function projectCopy (data) {
  return request.post('en/project/copy', data)
}
// 导入文件夹
export function folderLeadingIn (data) {
  return request.post('en/importFile/uploadFolder', data, 'formdata')
}
// 导入项目
export function projectLeadingIn (data) {
  return request.post('en/importFile/file', data)
}
// 导出项目
export function projectDown (data) {
  return request.get('en/exportFile/file', data)
}
export function getVersion () {
  return request.get('en/project/getVersion')
}
